export default {
  'sendpasswordsuccessfully.and': 'und',
  'sendpasswordsuccessfully.successfully': 'erfolgreich',
  'sendpasswordsuccessfully.passwordsentto': 'Link zur Passwortwiederherstellung per E-Mail senden ',
  'sendpasswordsuccessfully.checkemail':
    'Bitte checken Sie Ihre E-Mail, um Ihr Passwort zurückzusetzen',
  'sendpasswordsuccessfully.sendpassword': 'Passwort erfolgreich senden',
};
